<div data-parallax-video="true" [id]="ids" [ngClass]="classNames" data-jarallax-video="m4v:../../../../assets/video/01.m4v,webm:../../../../assets/video/01.webm,ogv:../../../../assets/video/01.ogv">
  <ng-content></ng-content>
</div>
